import { useState, useCallback } from 'react';
import { LayoutGrid, Table } from 'lucide-react';

// ListView — toggle riusabile Card/Tabella per le liste CRUD.
//
// NON duplica la logica di lista: espone all'utente i DUE rami di rendering che
// ogni pagina ha già (card via DataCard su mobile, <table> su desktop). Dati,
// righe e handler restano nella pagina. Su mobile la vista è sempre Card
// (il toggle non si mostra). Default desktop: Card. Preferenza per-lista in
// localStorage.
//
// Uso nella pagina:
//   const { isCards, mode, setMode } = useListMode('cantieri', isMobile);
//   ...toolbar:  {!isMobile && <ListModeToggle mode={mode} setMode={setMode} />}
//   ...corpo:    <ListView isCards={isCards} cards={cardsNode} table={tableNode} />

const keyFor = (page) => `listview_mode_${page}`;

export function useListMode(pageKey, isMobile) {
  const [mode, setModeState] = useState(() => {
    try { return localStorage.getItem(keyFor(pageKey)) === 'table' ? 'table' : 'cards'; }
    catch { return 'cards'; }
  });
  const setMode = useCallback((m) => {
    setModeState(m);
    try { localStorage.setItem(keyFor(pageKey), m); } catch { /* noop */ }
  }, [pageKey]);
  // Su mobile la <table> desktop non è adatta: si forza sempre Card.
  const isCards = isMobile || mode === 'cards';
  return { mode, setMode, isCards };
}

export function ListModeToggle({ mode, setMode }) {
  const opt = (m, label, Icon) => {
    const on = mode === m;
    return (
      <button
        type="button"
        onClick={() => setMode(m)}
        aria-pressed={on}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 12px',
          borderRadius: 'var(--radius-base)', border: 'none', cursor: 'pointer',
          fontSize: 12.5, fontWeight: 500,
          background: on ? 'var(--ds-bg)' : 'transparent',
          color: on ? 'var(--ink)' : 'var(--ds-muted)',
          boxShadow: on ? '0 1px 2px rgba(31,42,40,.08)' : 'none',
        }}
      >
        <Icon size={15} strokeWidth={1.8} /> {label}
      </button>
    );
  };
  return (
    <div role="group" aria-label="Vista lista" style={{ display: 'inline-flex', gap: 2, background: 'var(--chip)', border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', padding: 3 }}>
      {opt('cards', 'Card', LayoutGrid)}
      {opt('table', 'Tabella', Table)}
    </div>
  );
}

export default function ListView({ isCards, cards, table }) {
  return isCards ? cards : table;
}
